import loadable from '@loadable/component';

export const PageFooterLoadable = loadable(() => import('./PageFooter'), {
  resolveComponent: (module) => module.PageFooter,
});
